<template>
  <form @submit.prevent="handleSubmit">
    <section class="page-forgot-password">
      <div class="container d-flex justify-content-center align-items-center min-vh-100">
        <div class="card p-4">
          <!-- Logo -->
          <div class="text-center mb-4">
            <div class="app-logo mb-2" aria-hidden="true">
              <i class="fas fa-bolt text-primary fs-1"></i>
            </div>
            <h1 class="h4 fw-bold mb-1">NeXt Instalações</h1>
            <p class="text-muted mb-0">Acesse sua conta para continuar</p>
          </div>

          <!-- Email -->
          <div class="mb-3 position-relative">
            <label for="email" class="form-label">{{ $t('page.auth.forgot_password.email') }}</label>
            <div class="position-relative">
              <i class="fa-solid fa-envelope input-icon" aria-hidden="true"></i>
              <input id="email" type="email" class="form-control ps-5" v-model.trim="formData.email" :placeholder="$t('page.auth.forgot_password.emailPlaceholder')" required autocomplete="email" />
            </div>
          </div>

          <!-- Botão -->
          <div class="d-grid">
            <button class="btn btn-primary" type="submit" :disabled="loading">
              <i v-if="loading" class="fas fa-spinner fa-spin me-2"></i>
              {{ loading ? $t('page.auth.forgot_password.sending_link') : $t('page.auth.forgot_password.send_link') }}
            </button>
          </div>

          <!-- Mensagem de sucesso -->
          <div v-if="sent" class="alert alert-success text-center py-2 mb-3">
            <i class="fas fa-check-circle me-1"></i>
            {{ $t('page.auth.forgot_password.success') }}
          </div>

          <!-- Link para Login -->
          <div class="text-center">
            <p class="text-muted mb-0">
              {{ $t('page.auth.forgot_password.back_to_login') }}
              <router-link :to="{ name: 'login' }" class="fw-semibold text-decoration-none">
                {{ $t('page.auth.forgot_password.go_login') }}
              </router-link>
            </p>
          </div>

          <!-- Footer -->
          <div class="text-center mt-3">
            <small class="text-muted">© 2019 - {{ new Date().getFullYear() }} Next Instalações</small>
          </div>
        </div>
      </div>
    </section>
  </form>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/authStore";

// Consts
const router = useRouter();
const authStore = useAuthStore();

// States
const formData = ref({
  email: "",
});
const loading = ref(false);
const sent = ref(false);

// Handlers
const handleSubmit = async () => {
  if (!formData.value.email) return;

  loading.value = true;
  try {
    await authStore.forgotPassword(formData.value);
    sent.value = true;
  } catch (error) {
    console.error(error.response?.data?.message);
  } finally {
    loading.value = false;
  }
};

// Mounted
onMounted(() => {
  if (authStore.isAuthenticated) {
    router.push({ name: "home" }).catch(() => { });
  }
});
</script>

<style scoped>
.page-forgot-password {
  background: linear-gradient(135deg, #2c3e50, #4a6580);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.card {
  width: 100%;
  max-width: 420px;
  border-radius: 1rem;
  background: #fff;
  box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
}

.app-logo {
  width: 70px;
  height: 70px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.input-icon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 0.95rem;
  pointer-events: none;
}

.password-toggle:focus {
  outline: none;
  box-shadow: none;
}

.form-control.ps-5 {
  padding-left: 2.5rem !important;
}

.form-control.pe-5 {
  padding-right: 2.5rem !important;
}

.form-control {
  height: 44px;
  border-radius: 8px;
}

.btn {
  height: 44px;
  border-radius: 8px;
}

@media (max-width: 576px) {
  .page-register {
    background: none;
  }

  .card {
    border: none;
    border-radius: none;
    box-shadow: none !important;
  }
}
</style>
